import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";
import moment from "moment";

// Main columns configuration
export const emergencySuppliesCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Water Supply": [
      {
        title: "Amount Per Person",
        dataIndex: "Amount Per Person",
        key: "amountperperson",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Storage Location",
        dataIndex: "Storage Location",
        key: "storagelocation",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Food Inventory": [
      {
        title: "Quantities",
        dataIndex: "Quantities",
        key: "quantities",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Storage Location",
        dataIndex: "Storage Location",
        key: "storagelocation",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Types",
        dataIndex: "Types",
        key: "types",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expirationdate",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Special Dietary Needs": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Dietary Needs",
        dataIndex: "Dietary Needs",
        key: "dietaryneeds",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Medical Devices and Supplies": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "First Aid Kit Information": [
      {
        title: "First Aid Kit Name",
        dataIndex: "First Aid Kit Name",
        key: "firstaidkitname",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Contents",
        dataIndex: "Contents",
        key: "contents",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Prescription Medications": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Who's Prescription",
        dataIndex: "Who's Prescription",
        key: "who's prescription",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Dosage",
        dataIndex: "Dosage",
        key: "dosage",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Frequency",
        dataIndex: "Frequency",
        key: "frequency",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Expiration Date",
        dataIndex: "Expiration Date",
        key: "expiration date",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      actionColumn,
    ],
    "Emergency Equipment": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    Flashlights: [
      {
        title: "Number",
        dataIndex: "Number",
        key: "number",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    Batteries: [
      {
        title: "Number",
        dataIndex: "Number",
        key: "number",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Size",
        dataIndex: "Size",
        key: "size",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    Radio: [
      {
        title: "Power Method",
        dataIndex: "Power Method",
        key: "power method",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Phone Chargers": [
      {
        title: "For Which Device",
        dataIndex: "For Which Device",
        key: "for which device",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Length",
        dataIndex: "Length",
        key: "length",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Tools Emergency Supplies Inventory": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },

      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Clothing and Bedding": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },

      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },

      {
        title: "For Whom",
        dataIndex: "For Whom",
        key: "for whom",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Cash Emergency Supplies Inventory": [
      {
        title: "Item",
        dataIndex: "Item",
        key: "item",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },

      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
